import { ALERT } from '../../model/msg/equip';
import { getSearchEquipLayerSearchFormTpl } from '../../model/tpl/equip';
import { getSearchEquipItems } from '../../utils/service';
import {
  isDefined,
  isObject,
  isFunction,
  isInteger,
  not,
  truthy,
  falsy,
  notSingleEle,
  anyOf,
  parseInt10,
  each,
  minNumber
} from '../../../../utils/util';
import { API_DOMAIN_DEFAULT } from '../../../../model/model';
import { handleApiError } from '../../../../utils/service';
import SingletonLoading from '../../utils/SingletonLoading'

class SearchEquipLayer {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) throw new Error('SearchEquipLayer constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      global: window,
      pageSize: 20,
      paginationSize: 10
    }, options);

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.suggestKeywords = null;

    _.searchInput = null;

    _.searchData = {
      fex1: '',
      fex2: '',
      slotId: '',
      serverId: ''
    };

    _.currentPage = 1;
    _.paginationNavi = {};

    _.displayNoSearchItem = null;

    _.modal = null;

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('wrap must be single element.');

    _.searchInput = $('#suggestInput', _.wrap);

    _.displayNoSearchItem = $('.section-searchresult .nodata');

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.showNoSearchItem(false);

    if (isFunction(nc.lineage.modal)) {
      _.modal = nc.lineage.modal({
        wrapClass: 'ui-modal',
        overlay: {
          opacity: 0,
          appendTo: $('body')
        },
        contents: _.wrap,
        hideCallback: function(evt) {
          // set searchInput focusout, reset text value.
          $(`#suggestForm [data-name='suggest_delete']`).click();
        }
      });
    }

    _.searchInput.on('keyup', function (evt) {
      evt.preventDefault();

      if (anyOf(evt.originalEvent.key === 'Enter', evt.originalEvent.keyCode === 13)) return;
    });

    $('.icon-close', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      $(_).trigger({type: SearchEquipLayer.EVT_CLOSE});
    });
  }

  setEquipItems(items = []) {
    const _ = this;

    const itemsWrap = $('.section-searchresult ul', _.wrap);
    itemsWrap.off('click.item', 'li');
    itemsWrap.empty();

    const searchStr = _.searchInput.val();

    if (items.length <= 0) {
      _.showNoSearchItem(true);

    } else {
      _.showNoSearchItem(false);

      let itemsTpl = '', itemName = '';
      each(items, (item) => {
        itemName = (item.enchant >= 0) ? `+${item.enchant} ${item.itemName}` : `-${item.enchant} ${item.itemName}`;
        itemName = itemName.split(searchStr).join(`<strong>${searchStr}</strong>`);

        itemsTpl += `<li data-id="${item.itemId}" data-enchant="${item.enchant}" data-price="${item.price}" data-name="${item.itemName}" data-slot="${item.slot}" data-style="${item.style}" data-type="${item.type}" data-is-cash-item="${item.cashItem}" data-is-event-item="${item.eventItem}">
            <div class="item-icon"><img src="${item.itemImageUrl}" alt="${item.type}"></div>
            <div class="item-name">${itemName}</div>
            <div class="item-price">${item.displayPrice}</div>
          </li>`
      });

      itemsWrap.on('click.item', 'li', function (evt) {
        evt.preventDefault();

        const $item = $(this);
        console.log('$item :', $item);

        $(_).trigger({
          type: SearchEquipLayer.EVT_SELECT_EQUIP,
          obj: {
            itemId: $item.attr('data-id'),
            enchant: $item.attr('data-enchant'),
            price: $item.attr('data-price'),
            itemName: $item.attr('data-name'),
            slot: $item.attr('data-slot'),
            style: $item.attr('data-style'),
            type: $item.attr('data-type'),
            cashItem: ( $item.attr('data-is-cash-item') === 'true' ) ? true : false, // 2022.01  isCashItem -> cashItem
            eventItem: ( $item.attr('data-is-event-item') === 'true' ) ? true : false, // 2022.01 isEventItem  -> eventItem
            itemImageUrl: $('.item-icon img', $item).attr('src') || ''
          }
        });
      });

      itemsWrap.append(itemsTpl);
    }
  }

  setSuggestKeywords(data = {fex1: '', fex2: '', slotId: '', serverId: ''}) {
    const _ = this;

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=89742652
    const params = {
      // server_id: data.serverId, //  data.serverId,
      // equip_type: data.fex1,
      // equip_job: data.fex2,
      // page_size: 10,
      serverId: data.serverId,
      type: data.fex1,
      job: data.fex2,
      size: 10
    };

    if(isDefined(_.suggestKeywords)) {
      _.suggestKeywords.changeAddParam(params);

    } else {
      _.suggestKeywords = new _.global.AutoSuggest();

      // apiUrl: '/bns/bidder/search/suggest.web',
      //     selector : '#suggestForm',
      //     service: 'bns',
      //     alias: 'item',
      //     size: 5,
      //     useDelbtn: true,
      //     responseListName1 : 'saleSearchSuggestList',
      //     responseListName2 : 'list',
      //     queryName : 'q',
      //     submitCallback: function(_q){
      //   marketSearch()
      // }

      _.suggestKeywords.init({
        apiUrl: `${_.option.searchApiDomain}/lineage/search/v2/equip/suggest`,
        selector: '#suggestForm',
        service: 'lineage',
        alias: 'equip',
        queryName: 'keyword',
        responseListName1 : 'list',
        size: 10,
        submitCallback: $.proxy(_.searchItemBySuggestCallback, _),
        addParam: params,
        useDelbtn: true
      });
    }

    _.searchData = data;
  }

  searchItemBySuggestCallback(page) {
    const _ = this;

    page = isInteger(page) ? page : 1;

    const keyword = _.searchInput.val();

    if (keyword.length <= 0) {
      _.global.alert(ALERT.INPUT_SEARCH_KEYWORD);

    } else {
      _.searchItemByPageIndex(page);
    }
  }

  searchItemByPageIndex(page) {
    const _ = this;

    // console.log('_.option.searchApiDomain : ', _.option.searchApiDomain);
    getSearchEquipItems({
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      sendData: {
        serverId: parseInt10(_.searchData.serverId), // parseInt10(_.searchData.serverId),
        // query: _.searchInput.val(),
        keyword: _.searchInput.val(),
        job: _.searchData.fex2, // category: _.searchData.fex2,
        type: _.searchData.fex1,
        slot: _.searchData.slotId,
        size: 10,
        page: page
      },
      beforeSend: () => _.loading.start()

    }).then(function (data, textStatus, jqXHR) {
      _.loading.end();

      if (isObject(data)) {
        _.setEquipItems(data.list);// _.setEquipItems(data.equipItemList);

        _.currentPage = data.pagination.page; // _.currentPage = data.pagination.currentPage;

        // currentPage: 1
        // displayCount: 10
        // end: 10
        // maxPageNo: 64
        // next: true
        // previous: false
        // start: 1
        // totalCount: 632

        // endPage: 64
        // page: 1
        // size: 10
        // total: 632

        _.paginationNavi.start = Math.floor((data.pagination.page - 1) * _.option.paginationSize + 1 ); // Math.floor((data.pagination.page - 1) / _.option.paginationSize) * _.option.paginationSize + 1;
        _.paginationNavi.end = minNumber(_.paginationNavi.start + 9 , data.pagination.total); // minNumber(Math.ceil(data.pagination.page / _.option.paginationSize) * _.option.paginationSize, data.pagination.endPage);
        _.paginationNavi.maxPageNo = data.pagination.endPage;
        _.paginationNavi.totalCount = data.pagination.total;
        _.paginationNavi.currentPage = data.pagination.page;
        _.paginationNavi.previous = _.paginationNavi.start > 1;
        _.paginationNavi.next = _.paginationNavi.start + 10 < data.pagination.total;

        console.log('# _.paginationNavi : ', _.paginationNavi,  _.currentPage );
        _.setPagination(_.paginationNavi);

      } else {
        _.global.alert(ALERT.FAIL_LOAD_EQUIP_ITEMS); // '현재 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch(function (err) {
      console.log('getSearchEquipItems - error :', err);

      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_EQUIP_ITEMS); // '현재 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  setPagination(data = null) {
    const _ = this,
      paginationWrap = $('.pagination', _.wrap);

    $(_.wrap).off('click.prevbtn').off('click.nextbtn');

    paginationWrap.empty();

    console.log('#setPagination data: ', data);

    if (isDefined(data)) {
      paginationWrap.append(_.getPaginationTpl(data));

      $(_.wrap).on('click.prevbtn', '.btn.prev', function (evt) {
          const pageIndex = (_.currentPage < 1) ? 1 : _.currentPage - 1;
          _.searchItemByPageIndex(pageIndex);
        })
        .on('click.nextbtn', '.btn.next', function (evt) {
          const pageIndex = (_.currentPage >= data.maxPageNo) ? data.maxPageNo : _.currentPage + 1;
          console.log('pageIndex :', pageIndex);
          _.searchItemByPageIndex(pageIndex);
        });
    }
  }

  getPaginationTpl(data) {
    const DISABLED_STR = 'disabled="disabled"';
    let prevBtn = '', pageBtns = '', nextBtn = '';

    console.log('#getPaginationTpl data: ', data);

    if (data.totalCount > 0) {
      prevBtn = `<button class="btn prev" ${(!data.previous) ? DISABLED_STR : ''}>이전</button>`;
      pageBtns = `<span class="page">
                  <strong>${data.start}-${data.end}</strong> / ${data.totalCount}
                </span>`;
      nextBtn = `<button class="btn next" ${(!data.next) ? DISABLED_STR : ''}>다음</button>`;
    }

    return `${prevBtn}${pageBtns}${nextBtn}`;
  }

  showNoSearchItem(flag) {
    const _ = this;

    (truthy(flag)) ? _.displayNoSearchItem.show() : _.displayNoSearchItem.hide();
  }

  /*
   * public methods
   */
  show(flag) {
    (truthy(flag)) ? this.modal.show() : this.modal.hide();
  }

  focusSearchInput() {
    this.searchInput.focus();
  }

  setSearchData(data = {fex1: '', fex2: '', slotId: '', serverId: ''}) {
    this.reset();
    this.setSuggestKeywords(data);
  }

  reset() {
    const _ = this;

    // remove evt handlers
    if (_.searchInput.length > 0) _.searchInput.off('keyup');

    // reset search form tpl
    const searchFormTpl = getSearchEquipLayerSearchFormTpl();

    $('.wrap-section-searchform').replaceWith(searchFormTpl);

    _.searchInput = $('#suggestInput', _.wrap);

    const itemsWrap = $('.section-searchresult ul', _.wrap);
    itemsWrap.off('click.item', 'li');
    itemsWrap.empty();

    _.setPagination(null);
  }

  destroy(obj = null) {
    const _ = this;

    if (isDefined(_.modal)) {
      _.modal.destroy();
      _.modal = null;
    }

    if (_.searchInput) _.searchInput.off('keyup');

    $('.icon-close', _.wrap).off('click');

    const itemsWrap = $('.section-searchresult ul', _.wrap);
    itemsWrap.off('click.item', 'li');

    _.setPagination(null);
  }
}

SearchEquipLayer.EVT_SELECT_EQUIP = 'EVT_SELECT_EQUIP';
SearchEquipLayer.EVT_CLOSE = 'EVT_CLOSE';

export default SearchEquipLayer;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/searchEquipLayer/SearchEquipLayer.js